export { default } from './AllergensDescriptions';
